import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollProgress from "@/components/ScrollProgress";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AmenitiesSection from "@/components/AmenitiesSection";
import WhoIsItFor from "@/components/WhoIsItFor";
import GallerySection from "@/components/GallerySection";
import PricingSection from "@/components/PricingSection";
import LocationSection from "@/components/LocationSection";
import DemoBookingSection from "@/components/DemoBookingSection";
import FinalCtaSection from "@/components/FinalCtaSection";
import Footer from "@/components/Footer";
import MobileCTABar from "@/components/MobileCTABar";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import AdminPage from "@/components/admin/AdminPage";

function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 0.95, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen overflow-x-clip bg-canvas font-sans text-ink antialiased">
            <ScrollProgress />
            <Navbar />
            <main>
                <HeroSection />
                <AmenitiesSection />
                <WhoIsItFor />
                <GallerySection />
                <PricingSection />
                <LocationSection />
                <DemoBookingSection />
                <FinalCtaSection />
            </main>
            <Footer />
            <MobileCTABar />
            <WhatsAppWidget />
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <Toaster position="top-center" richColors />
        </BrowserRouter>
    );
}
